import ToBooleanText from '../../components/utilities/Table/helperKIvaTable';
import { RequestWarranty } from '../../components/utilities/Table/generalColumns/RequestWarranty';

const commonColumns = [
    RequestWarranty,
    ToBooleanText('tramite', 'Tramite voluntario', 'tramite_voluntario'),
    {
        Header: 'Nro crédito',
        accessor: 'credito.num_credito',
    },
    {
        Header: 'Identificación',
        accessor: 'solicitud.persona.numero_identificacion',
    },

    {
        Header: 'Cliente',
        accessor: 'solicitud.persona.full_name',
        typeId: 'HeaderClient',
    },

    {
        Header: 'Producto',
        accessor: 'credito.subproducto.label',
    },

    {
        Header: 'Estado',
        accessor: 'estado.label',
    },
];

const requestsWarrantyList = [
    {
        id: 'bolsa_general',
        label: 'BOLSA GENERAL',
        responsable: false,
        status: '12,3,4,6',
        offices: true,
        columns: commonColumns,
        registrationLimit: 5,
        buttonAction: [{ name: 'takeRequestWarranty' }],
        // nameColumnProcessed: [
        //     {
        //         name: 'estado',
        //         value: 2,
        //         operator: '%26',
        //     },
        // ],
    },
    {
        id: 'proceso',
        label: 'EN PROCESO',
        offices: true,
        // responsable: true,
        columns: commonColumns,
        // columns: (() => {
        //     const cols = [...commonColumns];
        //     cols.splice(8, 0, {
        //         Header: 'SubEstado',
        //         accessor: 'subestado.label',
        //     });
        //     return cols;
        // })(),
        registrationLimit: 5,
        nameColumnProcessed: [
            {
                name: 'estado',
                value: 3,
                operator: '|',
            },
            {
                name: 'estado',
                value: 6,
                operator: '|',
            },
            {
                name: 'estado',
                value: 12,
                operator: '|',
            },
            {
                name: 'estado',
                value: 4,
                operator: '%26',
            },
            {
                name: 'responsable',
                value: 'user',
            },
        ],
    },
    {
        id: 'procesadas',
        label: 'PROCESADAS',
        responsable: false,
        columns: commonColumns,

        registrationLimit: 5,
        nameColumnProcessed: [
            {
                name: 'usuario_notificacion',
                value: 'user',
                operator: '|',
            },
            {
                name: 'usuario_radicacion',
                value: 'user',
                operator: '|',
            },
            {
                name: 'usuario_comercializacion',
                value: 'user',
                operator: '|',
            },
            {
                name: 'usuario_traspaso',
                value: 'user',
                operator: '|',
            },
            {
                name: 'usuario_desistimiento',
                value: 'user',
                operator: '%26',
            },
        ],
    },
];
export default requestsWarrantyList;
